"use client";

import Link from "next/link";

/** Replaces the root layout when the root layout itself throws. Includes full document + landmarks for crawlers / Lighthouse. */
export default function GlobalError({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <title>Error | C444 Game Pakistan</title>
        <meta
          name="description"
          content="A server error occurred while loading C444 Game Pakistan. Try again or return to the home page."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {/* Intentional: fatal errors must not be indexed */}
        <meta name="robots" content="noindex, nofollow" />
      </head>
      <body
        style={{
          margin: 0,
          fontFamily: "system-ui, sans-serif",
          background: "#003c2e",
          color: "#ffffff",
          minHeight: "100vh",
        }}
      >
        <main style={{ padding: "2rem", maxWidth: "36rem", margin: "0 auto" }}>
          <h1 style={{ fontSize: "1.5rem", color: "#ffea00" }}>
            Something went wrong
          </h1>
          <p style={{ color: "#c0c8d2", marginTop: "1rem", lineHeight: 1.6 }}>
            The site could not render this page. Use the button below or open
            the home page in a new visit.
          </p>
          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
            }}
          >
            <button
              type="button"
              onClick={() => reset()}
              style={{
                padding: "0.75rem 1.25rem",
                fontWeight: 700,
                cursor: "pointer",
                borderRadius: "0.5rem",
                border: "none",
                background: "#ffea00",
                color: "#000",
              }}
            >
              Try again
            </button>
            <Link
              href="/"
              style={{
                padding: "0.75rem 1.25rem",
                fontWeight: 700,
                color: "#ffea00",
                alignSelf: "center",
              }}
            >
              Home
            </Link>
          </div>
        </main>
      </body>
    </html>
  );
}
